import * as React from "react";
import AuthorDetails, { AuthorDetailsProps } from "~/components/author-details/author-details";

export interface IAuthorDetailsViewProps {
    contextModel: AuthorDetailsProps;
}

class AuthorDetailsView extends React.PureComponent<IAuthorDetailsViewProps> {
    public render() {
        return <AuthorDetails {...this.props.contextModel} />;
    }
}

export default AuthorDetailsView;
